import React, { useState, useEffect } from "react";
import SectionHeader from "./components/SectionHeader";
import DesktopVideoCarousel from "./components/DesktopVideoCarousel";
import MobileVideoCarousel from "./components/MobileVideoCarousel";
import useCarouselNavigation from "./hooks/useCarouselNavigation";
import useDesktopCarousel from "./hooks/useDesktopCarousel";
import useMobileCarousel from "./hooks/useMobileCarousel";
import useTouchGestures from "./hooks/useTouchGestures";
import { LOADING_DELAY } from "./utils/constants";

export default function SectionBell({ slice, path }) {
  const [isLoading, setIsLoading] = useState(true);

  const videos = slice?.items || [];
  const { badge, title } = slice?.primary || {};

  const { activeIndex, setActiveIndex, goToPrevious, goToNext } =
    useCarouselNavigation(videos.length);

  const { desktopContainerRef, containerDimensions, translateX } =
    useDesktopCarousel(activeIndex, videos.length);

  const { mobileCarouselRef, thumbnailRefs, handleMobileScroll } =
    useMobileCarousel(activeIndex, setActiveIndex, videos.length);

  const { handleTouchStart, handleTouchMove, handleTouchEnd } =
    useTouchGestures(activeIndex, videos.length, goToNext, goToPrevious);

  // Simulate loading completion
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), LOADING_DELAY);
    return () => clearTimeout(timer);
  }, []);

  if (!videos.length) {
    return (
      <div className="bg-[#0f0624] min-h-screen flex items-center justify-center">
        <div className="text-white text-lg">No videos available</div>
      </div>
    );
  }

  return (
    <div className={`bg-[#0f0624] ${path === "ai-after-hours" ? "mt-20" : ""}`}>
      <div className="md:max-w-7xl px-6 xl:px-16 mx-auto py-10">
        {/* Desktop Design */}
        <div className="hidden lg:block">
          <SectionHeader badge={badge} title={title} />
          <DesktopVideoCarousel
            videos={videos}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
            goToPrevious={goToPrevious}
            goToNext={goToNext}
            isLoading={isLoading}
            desktopContainerRef={desktopContainerRef}
            containerDimensions={containerDimensions}
            translateX={translateX}
          />
        </div>

        {/* Mobile Design */}
        <div className="block lg:hidden">
          <SectionHeader badge={badge} title={title} isMobile={true} />
          <MobileVideoCarousel
            videos={videos}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
            isLoading={isLoading}
            mobileCarouselRef={mobileCarouselRef}
            thumbnailRefs={thumbnailRefs}
            handleMobileScroll={handleMobileScroll}
            handleTouchStart={handleTouchStart}
            handleTouchMove={handleTouchMove}
            handleTouchEnd={handleTouchEnd}
          />
        </div>
      </div>

      <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
}
